import { CURRENT_CLIENT } from '@/constants/index'
import type { AuthMarketingShellConfig, ClientAuthConfig } from '@/types/client-auth'

export type { AuthMarketingShellConfig } from '@/types/client-auth'

export function getAuthMarketingShellConfig(): AuthMarketingShellConfig | null {
  const shell = (CURRENT_CLIENT as { auth?: ClientAuthConfig }).auth?.marketingShell
  if (!shell?.enabled) return null
  return shell
}
